import numberFormat from "./Utils";
import { CapitalsResponse } from "../api/request/Lead/Interfaces/DataInterface.response";
import { TraitName } from "../api/request/Lead/Interfaces/TraitTypes";

const traitToCamelCase = (trait: string): string =>
  trait
    .toLowerCase()
    .trim()
    .replace(/[-_\s]+(.)?/g, (_: string, c: string) =>
      c ? c.toUpperCase() : ""
    );

export const renderCoverages = (coverages: any, translate: any) => {
  return (
    <div>
      {coverages.map(
        (key: any) =>
          key !== "DEATH" && (
            <div key={key} className="flex flex-row">
              <span className="BodyM font-light text-[#7B7B7B]">
                +{" "}
                {translate(
                  `payment.multiproduct.${traitToCamelCase(key)}`
                )}
              </span>
            </div>
          )
      )}
    </div>
  );
};

export const renderCoveragesWithCapitals = (
  capitals: CapitalsResponse | undefined,
  translate: (key: string) => string,
  options: { includeDeath?: boolean } = {}
) => {
  if (!capitals) return null;
  const { includeDeath = false } = options;
  const traits = (Object.keys(capitals) as TraitName[]).filter((key) => {
    if (!capitals[key]?.active) return false;
    if (!includeDeath && key === "DEATH") return false;
    return true;
  });
  if (traits.length === 0) return null;
  return (
    <div>
      {traits.map((key) => (
        <div key={key} className="flex flex-row">
          <span className="BodyM font-light text-[#7B7B7B]">
            {includeDeath ? "" : "+ "}
            {translate(`payment.multiproduct.${traitToCamelCase(key)}`)}
            {`: ${numberFormat(capitals[key]?.capital ?? 0, "capital")}`}
          </span>
        </div>
      ))}
    </div>
  );
};
